import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
// Move-In integration disabled — pending integration
// import { Dialog } from 'primereact/dialog';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import Layout from '../component/layout'
import { getItem } from '../../../utils/localStorage';
import { makeRequest2 } from '../../../utils/makeRequest';
import { toastify } from '../../../utils/toast';
import { filterObjectsByAllProperties } from '../../../utils/filterSearch';
import { getUnitsForFacility } from '../../../utils/urls';
// Move-In integration disabled — pending integration
// import {
//     getFacilityMoveInUnitsURL,
//     upsertFacilityMoveInListingURL,
//     submitFacilityMoveInListingURL,
// } from '../../../utils/urls';

function UnitManagement() {
    const [units, setUnits] = useState([]);
    const [allUnits, setAllUnits] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [facilityId, setFacilityId] = useState(null);
    // Move-In integration disabled — pending integration
    // const [moveInDialogVisible, setMoveInDialogVisible] = useState(false);
    // const [selectedUnit, setSelectedUnit] = useState(null);
    // const [savingMoveIn, setSavingMoveIn] = useState(false);
    // const [moveInForm, setMoveInForm] = useState({
    //     title: '',
    //     listingType: 'Apartment',
    //     price: '',
    //     bedrooms: '',
    //     bathrooms: '',
    //     grossArea: '',
    //     locationAddress: '',
    //     locationCity: '',
    //     locationCounty: '',
    //     amenities: '',
    //     landmarks: '',
    //     nearbyServices: '',
    //     imageUrls: '',
    //     description: '',
    // });

    // const splitLines = (value) => String(value || '').split('\n').map((item) => item.trim()).filter(Boolean);
    // const joinLines = (value) => Array.isArray(value) ? value.join('\n') : '';

    const fetchUnitsForFacility = async () => {
        try {
            const value = await getItem('selectedFacilityId')
            setFacilityId(value);
            const response = await makeRequest2(`${getUnitsForFacility}/${value}`, 'GET', {});

            if (response.success) {
                const payload = Array.isArray(response.data?.data) ? response.data.data : response.data;
                setUnits(payload);
                setAllUnits(payload);
            } else {
                throw new Error('Failed to fetch units')
            }
        } catch (error) {
            console.log(error.message)
            toastify(error.message, 'error');
        }
    };

    const handleInputSearch = async (value) => {
        try {
            setSearchTerm(value);
            if (value === '') {
                setUnits(allUnits);
            } else {
                const results = await filterObjectsByAllProperties(allUnits, value);
                setUnits(results);
            }
        } catch (error) {
            toastify(error.message, 'error');
        }
    };

    const handleUnitClick = (rowData) => {
        return (
            <Link to={'/facility/unit_management/view_unit/' + rowData._id} style={{ color: 'royalblue' }}>
                {rowData.name}
            </Link>
        )
    }

    /* Move-In integration disabled — pending integration
    const openMoveInDialog = (rowData) => {
        setSelectedUnit(rowData);
        setMoveInForm({
            title: rowData.moveInTitle || rowData.name || '',
            listingType: rowData.moveInListingType || rowData.unitType || 'Apartment',
            price: rowData.moveInPrice || '',
            bedrooms: rowData.moveInBedrooms ?? rowData.bedrooms ?? '',
            bathrooms: rowData.moveInBathrooms ?? rowData.bathrooms ?? '',
            grossArea: rowData.grossArea || '',
            locationAddress: rowData.moveInLocationAddress || rowData.facilityLocation?.address || '',
            locationCity: rowData.moveInLocationCity || rowData.facilityLocation?.city || '',
            locationCounty: rowData.moveInLocationCounty || rowData.facilityLocation?.county || '',
            amenities: joinLines(rowData.moveInAmenities),
            landmarks: joinLines(rowData.moveInLandmarks),
            nearbyServices: joinLines(rowData.moveInNearbyServices),
            imageUrls: joinLines(rowData.moveInImages),
            description: rowData.moveInDescription || '',
        });
        setMoveInDialogVisible(true);
    };

    const updateMoveInForm = (field, value) => {
        setMoveInForm((current) => ({ ...current, [field]: value }));
    };

    const saveMoveInListing = async (submit = false) => {
        if (!selectedUnit || !facilityId) return;

        setSavingMoveIn(true);
        try {
            const body = {
                ...moveInForm,
                price: Number(moveInForm.price),
                bedrooms: moveInForm.bedrooms === '' ? null : Number(moveInForm.bedrooms),
                bathrooms: moveInForm.bathrooms === '' ? null : Number(moveInForm.bathrooms),
                grossArea: moveInForm.grossArea === '' ? null : Number(moveInForm.grossArea),
                amenities: splitLines(moveInForm.amenities),
                landmarks: splitLines(moveInForm.landmarks),
                nearbyServices: splitLines(moveInForm.nearbyServices),
                imageUrls: splitLines(moveInForm.imageUrls),
                submit,
            };
            const url = submit
                ? `${submitFacilityMoveInListingURL}/${facilityId}/${selectedUnit._id}/submit`
                : `${upsertFacilityMoveInListingURL}/${facilityId}/${selectedUnit._id}/listing`;
            const response = await makeRequest2(url, 'PUT', body);
            if (!response.success) {
                throw new Error(response.error || 'Failed to save Move-In listing');
            }
            toastify(response.data?.message || 'Move-In listing saved', 'success');
            setMoveInDialogVisible(false);
            setSelectedUnit(null);
            await fetchUnitsForFacility();
        } catch (error) {
            toastify(error.message, 'error');
        } finally {
            setSavingMoveIn(false);
        }
    };

    const moveInStatusBody = (rowData) => {
        const approval = rowData.moveInApproval;
        const status = rowData.moveInStatus;
        if (approval === 'approved' && rowData.listedInMoveIn) {
            return <span className="badge bg-success">Listed</span>;
        }
        if (approval === 'pending' || status === 'pending_approval') {
            return <span className="badge bg-warning text-dark">Awaiting Approval</span>;
        }
        if (approval === 'rejected') {
            return <span className="badge bg-danger">Rejected</span>;
        }
        if (status === 'draft') {
            return <span className="badge bg-secondary">Draft</span>;
        }
        return <span className="badge bg-light text-dark border">Not Listed</span>;
    };

    const moveInReadinessBody = (rowData) => {
        const percent = rowData.completeness?.percent ?? 0;
        const missing = rowData.completeness?.missingLabels || [];
        return (
            <div style={{ minWidth: 120 }}>
                <div className="progress" style={{ height: 6 }}>
                    <div className="progress-bar" style={{ width: `${percent}%` }} />
                </div>
                <small className="text-muted" title={missing.join(', ')}>
                    {percent}% complete
                </small>
            </div>
        );
    };

    const moveInActionBody = (rowData) => {
        const label = rowData.moveInListingId ? 'Edit Move-In' : 'List on Move-In';
        return (
            <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => openMoveInDialog(rowData)}
            >
                <i className="ti ti-home-share me-1"></i>{label}
            </button>
        );
    };

    const renderMoveInDialogFooter = () => (
        <div className="d-flex justify-content-end gap-2">
            <button
                type="button"
                className="btn btn-light"
                disabled={savingMoveIn}
                onClick={() => setMoveInDialogVisible(false)}
            >
                Cancel
            </button>
            <button
                type="button"
                className="btn btn-outline-primary"
                disabled={savingMoveIn}
                onClick={() => saveMoveInListing(false)}
            >
                Save Draft
            </button>
            <button
                type="button"
                className="btn btn-primary"
                disabled={savingMoveIn}
                onClick={() => saveMoveInListing(true)}
            >
                Submit for Approval
            </button>
        </div>
    );
    */

    useEffect(() => {
        fetchUnitsForFacility();
    }, []);

    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/unit_management"}>Unit Management</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Units</h5>
                                </div>
                                <div className='card-body'>
                                    <div className="row">
                                        <div className="col-lg-12 col-xxl-12">
                                            <div className="card">
                                                <div className="card-body position-relative">
                                                    <div className="row">
                                                        <div className='col-md-4'>
                                                            <div className="form-search">
                                                                <i className="ti ti-search"></i>
                                                                <input type="search" className="form-control" placeholder="Search Here"
                                                                    value={searchTerm}
                                                                    onChange={(e) => {
                                                                        handleInputSearch(e.target.value)
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="dt-responsive table-responsive mt-4">
                                                                <DataTable value={units}
                                                                    emptyMessage="No Units found."
                                                                    sortMode="multiple"
                                                                    paginator rows={10}
                                                                    stripedRows tableStyle={{ minWidth: '50rem' }}
                                                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} units"
                                                                    rowsPerPageOptions={[10, 15, 25, 50, 75, 100]}
                                                                >
                                                                    <Column header="Name"
                                                                        body={handleUnitClick}
                                                                    ></Column>
                                                                    <Column field="unitType" header="Type"></Column>
                                                                    <Column field="division" header="Block"></Column>
                                                                    <Column field="floorUnitNo" header="Floor"></Column>
                                                                    {/* Move-In integration disabled — pending integration
                                                                    <Column header="Move-In" body={moveInStatusBody}></Column>
                                                                    <Column header="Readiness" body={moveInReadinessBody}></Column>
                                                                    <Column header="Actions" body={moveInActionBody}></Column>
                                                                    */}
                                                                </DataTable>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Move-In integration disabled — pending integration
            <Dialog
                header={selectedUnit ? `Move-In listing: ${selectedUnit.name}` : 'Move-In listing'}
                visible={moveInDialogVisible}
                style={{ width: 'min(980px, 95vw)' }}
                modal
                footer={renderMoveInDialogFooter()}
                onHide={() => setMoveInDialogVisible(false)}
            >
                <div className="row g-3">
                    <div className="col-md-8">
                        <label className="form-label">Listing title</label>
                        <input className="form-control" value={moveInForm.title} onChange={(e) => updateMoveInForm('title', e.target.value)} />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Listing type</label>
                        <select className="form-select" value={moveInForm.listingType} onChange={(e) => updateMoveInForm('listingType', e.target.value)}>
                            <option>Apartment</option>
                            <option>Studio</option>
                            <option>Bedsitter</option>
                            <option>Bungalow</option>
                            <option>Maisonette</option>
                            <option>Townhouse</option>
                            <option>Villa</option>
                            <option>Office</option>
                        </select>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Price (KES/mo)</label>
                        <input type="number" className="form-control" value={moveInForm.price} onChange={(e) => updateMoveInForm('price', e.target.value)} />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Bedrooms</label>
                        <input type="number" className="form-control" value={moveInForm.bedrooms} onChange={(e) => updateMoveInForm('bedrooms', e.target.value)} />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Bathrooms</label>
                        <input type="number" className="form-control" value={moveInForm.bathrooms} onChange={(e) => updateMoveInForm('bathrooms', e.target.value)} />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Floor area</label>
                        <input type="number" className="form-control" value={moveInForm.grossArea} onChange={(e) => updateMoveInForm('grossArea', e.target.value)} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Address</label>
                        <input className="form-control" value={moveInForm.locationAddress} onChange={(e) => updateMoveInForm('locationAddress', e.target.value)} />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">City</label>
                        <input className="form-control" value={moveInForm.locationCity} onChange={(e) => updateMoveInForm('locationCity', e.target.value)} />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">County</label>
                        <input className="form-control" value={moveInForm.locationCounty} onChange={(e) => updateMoveInForm('locationCounty', e.target.value)} />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Amenities</label>
                        <textarea className="form-control" rows="4" placeholder="One per line" value={moveInForm.amenities} onChange={(e) => updateMoveInForm('amenities', e.target.value)} />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Landmarks</label>
                        <textarea className="form-control" rows="4" placeholder="One per line" value={moveInForm.landmarks} onChange={(e) => updateMoveInForm('landmarks', e.target.value)} />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Nearby services</label>
                        <textarea className="form-control" rows="4" placeholder="Schools, hospitals, malls..." value={moveInForm.nearbyServices} onChange={(e) => updateMoveInForm('nearbyServices', e.target.value)} />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label">Photo URLs</label>
                        <textarea className="form-control" rows="3" placeholder="One image URL per line" value={moveInForm.imageUrls} onChange={(e) => updateMoveInForm('imageUrls', e.target.value)} />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label">Description</label>
                        <textarea className="form-control" rows="5" value={moveInForm.description} onChange={(e) => updateMoveInForm('description', e.target.value)} />
                    </div>
                </div>
            </Dialog>
            */}
        </Layout>
    )
}


export default UnitManagement
